export enum ProductTabs {
    AboutProduct = 'about-product',
    Orders = 'orders',
}
